import React from 'react'

const AutocompleteListHeader = ({ title }) => {
  return (
    <div className="text-xs font-semibold uppercase tracking-widest text-gray-700">
      {title}
    </div>
  )
}

export default AutocompleteListHeader
